import { render, staticRenderFns } from "./MediaWithHeading.vue?vue&type=template&id=6210128b&"
import script from "./MediaWithHeading.vue?vue&type=script&lang=js&"
export * from "./MediaWithHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports